// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.daaSqIhz4AdjFD3gn236 input{border:0}.nAHVFICFAdjtqgj1F0C8{height:400px}`, "",{"version":3,"sources":["webpack://./src/components/dev-tools/dev-tools.scss"],"names":[],"mappings":"AAAA,4BACI,QAAA,CAGJ,sBACI,YAAA","sourcesContent":[".devTools input {\n    border: 0;\n}\n\n.contentSection {\n    height: 400px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"devTools": `daaSqIhz4AdjFD3gn236`,
	"contentSection": `nAHVFICFAdjtqgj1F0C8`
};
export default ___CSS_LOADER_EXPORT___;
